import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './style.scss';

function Navigation({ isNewsUserLogged, isLawsUserLogged, isLawsAvailable }) {
    const isBothUsers = isNewsUserLogged && isLawsUserLogged;
    return (
        <nav className="user-nav">
            {isBothUsers || isLawsUserLogged ? (
                <NavLink activeClassName="active" to="/user/settings" exact>
                    Настройки
                </NavLink>
            ) : null}
            {isLawsUserLogged && isLawsAvailable && (
                <NavLink activeClassName="active" to="/user/team" exact>
                    Команда
                </NavLink>
            )}
            {isLawsUserLogged && isLawsAvailable && (
                <NavLink activeClassName="active" to="/user/events" exact>
                    События
                </NavLink>
            )}
            {/* {isLawsUserLogged && isLawsAvailable && (
                <NavLink activeClassName="active" to="/user/feed" exact>
                    Лента
                </NavLink>
            )} */}
        </nav>
    );
}

Navigation.propTypes = {
    isNewsUserLogged: PropTypes.bool,
    isLawsUserLogged: PropTypes.bool,
    isLawsAvailable: PropTypes.bool,
};

export default Navigation;
export { Navigation };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/navigation/index.js